import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { FormatNumber, Text } from '@reveni-io/reveni-ui'

import { aggregatedSentiments } from '@/metrics/pages/ReasonMetricDetailPage/constants'
import { getSentimentPercentages } from '@/metrics/pages/ReasonMetricDetailPage/helpers'
import SentimentTag from '@/metrics/pages/ReasonMetricDetailPage/SentimentTag/SentimentTag'

import * as Styles from './styles'

const OverallSentiment = ({ sentiment, totalNotes }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const { negative, neutral, positive } = getSentimentPercentages(sentiment, totalNotes)

  return (
    <Styles.Container>
      <Text type="bodyMMedium">{t('Sentimiento general')}</Text>

      <Styles.Bar>
        <Styles.BarSegment width={negative} color={theme.colors.danger.default} />
        <Styles.BarSegment width={neutral} color={theme.colors.text.subtle} />
        <Styles.BarSegment width={positive} color={theme.colors.success.default} />
      </Styles.Bar>

      <Styles.Legend>
        <Styles.LegendItem>
          <Text type="bodyMMedium">
            <FormatNumber style="percent">{negative}</FormatNumber>
          </Text>
          <SentimentTag type={aggregatedSentiments.negative} label={t('Negativo')} />
        </Styles.LegendItem>
        <Styles.LegendItem>
          <Text type="bodyMMedium">
            <FormatNumber style="percent">{neutral}</FormatNumber>
          </Text>
          <SentimentTag type={aggregatedSentiments.neutral} label={t('Neutro')} />
        </Styles.LegendItem>
        <Styles.LegendItem>
          <Text type="bodyMMedium">
            <FormatNumber style="percent">{positive}</FormatNumber>
          </Text>
          <SentimentTag type={aggregatedSentiments.positive} label={t('Positivo')} />
        </Styles.LegendItem>
      </Styles.Legend>
    </Styles.Container>
  )
}

export default OverallSentiment
